import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import APIClient from '../teal-react/utils/APIClient';
import { useAuth } from '../teal-react/utils/token';
import K from '../Constants';
import Typo from '../teal-react/components/atoms/Typo';

const theme = createTheme();

export default function SignIn() {
  const api = new APIClient({ serverUrl: K.serverUrl });
  const navigate = useNavigate();
  const { setToken, user, token } = useAuth();
  const [footer, set_footer] = React.useState<any>();

  React.useEffect(() => {
    if (user && !user?.isRO) {
      api.Post('/html/auth/sso.php', {
        data: { token },
      });
    }
  }, [user, token]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const frm = new FormData(event.currentTarget);
    const data = {
      email: frm.get('email'),
      password: frm.get('password'),
    };
    api.Post('/auth', { data }).then((r: any) => {
      if (r.status === 200) {
        setToken(r.token);
        navigate('/', { replace: true });
        // api.Post('/html/auth/sso.php', {
        //   data: { token: r.token },
        // });
      } else {
        set_footer(Typo.error('Bad username or password'));
      }
    });
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>

          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            sx={{ mt: 1 }}
          >
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            {footer}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Sign In
            </Button>

            {/* <div style={{ textAlign: 'center' }}>
              <Button
                variant="text"
                onClick={() => navigate('/auth/reset')}
                style={{ fontSize: '.8em' }}
              >
                Forgot Password?
              </Button>
            </div> */}
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
}
